var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoVolumeOff = function SvgIcoVolumeOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    fillRule: "evenodd",
    d: "M10.293 20.706c.63.63 1.707.183 1.707-.707V4c0-.89-1.077-1.337-1.707-.707l-5.74 5.74a3 3 0 0 0 0 5.932zM18 13.414l1.293 1.293a1 1 0 0 0 1.414-1.414L19.414 12l1.293-1.293a1 1 0 1 0-1.414-1.414L18 10.586l-1.293-1.293a1 1 0 0 0-1.414 1.414L16.586 12l-1.293 1.293a1 1 0 1 0 1.414 1.414z",
    clipRule: "evenodd"
  })));
};
export default SvgIcoVolumeOff;